import React from "react";
import { LinkedInCallback } from "react-linkedin-login-oauth2";

const Linkedin = () => {
  return <LinkedInCallback />;
};

export default Linkedin;
